<template>
    <div class="agent-contact-info">
        <b-row v-if="phones.length">
            <b-col>
                <p
                    class="phone-number agent-info-text mb-0"
                    v-for="(phone, index) in phones"
                    :key="index"
                >
                    {{ phone.phone }}
                </p>
            </b-col>
        </b-row>

        <b-row v-if="email">
            <b-col>
                <p class="email agent-info-text">
                    {{ email }}
                </p>
            </b-col>
        </b-row>

        <b-row v-if="website">
            <b-col class="ellipsis">
                <b-link
                    class="website agent-info-text text-decoration-none link text-truncate"
                    :href="website.url"
                    target="_blank"
                >
                    {{ shortWebsite }}
                </b-link>
            </b-col>
        </b-row>

        <b-row class="my-3">
            <b-col>
                <template
                    v-for="(socialLink, index) in socialLinks"
                >
                    <b-button
                        v-if="socialLink.type !== WEBSITE"
                        :key="index"
                        class="border-0"
                        :href="socialLink.url"
                        target="_blank"
                    >
                        <i
                            class="social-link-icon fab"
                            :class="socialLinkIconMap[socialLink.type]"
                        />
                    </b-button>
                </template>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import './AgentContactInfo.scss';
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import {WEBSITE, FACEBOOK, YOUTUBE, INSTAGRAM, LINKEDIN, WHATSAPP, SKYPE}
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageSocialLinkAppResource";

    export default {
        name: "AgentContactInfo",
        
        mixins: [
            ShowNotificationMixin,
        ],
        
        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
        },
        
        data() {
            return {
                WEBSITE,
            };
        },

        computed: {
            phones() {
                return this.landingPage.phones;
            },

            socialLinks() {
                return this.landingPage.socialLinks;
            },

            email() {
                return this.landingPage.email;
            },

            website() {
                return this.socialLinks.toArray().find(socialLink => socialLink.type === WEBSITE);
            },

            shortWebsite() {
                if (! this.website) {
                    return;
                }

                return this.website.url.replace('http://', '')
                    .replace('https://', '');
            },

            socialLinkIconMap() {
                let map = [];

                map[FACEBOOK] = 'fa-facebook-f';
                map[YOUTUBE] = 'fa-youtube';
                map[INSTAGRAM] = 'fa-instagram';
                map[LINKEDIN] = 'fa-linkedin-in';
                map[WHATSAPP] = 'fa-whatsapp';
                map[SKYPE] = 'fa-skype';

                return map;
            }
        },
    };
</script>
